// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".answer-block[data-v-6c9c5886] ul{list-style-position:inside;list-style-type:disc;margin-bottom:.5rem;margin-top:.5rem}.answer-block[data-v-6c9c5886] ul li{padding-bottom:.5rem;padding-top:.5rem}.answer-block[data-v-6c9c5886] ul li p{display:inline}.answer-block[data-v-6c9c5886] ul ul{margin-bottom:0;margin-top:0;padding-left:1rem}.answer-block[data-v-6c9c5886] p.subheader{font-weight:700;margin-bottom:.5rem;margin-top:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
